import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalStorageEnum } from '@enums/local-storage.enum';
import { UrlEnum } from '@enums/url.enum';
import { ExtrasInfo } from '@services/extras/_interfaces_/extras-info.interface';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { UrlService } from '@services/url/url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExtrasOverviewService {
  private http = inject(HttpClient);
  private urlService = inject(UrlService);
  private localStorageService = inject(LocalStorageService);
  private extrasInfoData: ExtrasInfo;

  constructor() {}

  postExtrasInfo(flightIdentifier: string): Observable<ExtrasInfo> {
    const selectedFlightIdentifier: string = flightIdentifier;
    this.localStorageService.setRetrievedFlightIdentifier(selectedFlightIdentifier);
    const url: string = `${this.urlService.urls[UrlEnum.GET_EXTRAS_INFO]}`;
    const headers = { SessionId: this.localStorageService.getUserSessionToken() };
    const body = {
      retrievedFlightIdentifier: selectedFlightIdentifier,
    };
    return this.http.post<ExtrasInfo>(url, body, { headers });
  }

  setExtrasData(data: ExtrasInfo): void {
    this.extrasInfoData = data;
    localStorage.setItem(LocalStorageEnum.Extras_Info, JSON.stringify(data));
  }

  getExtrasData(): ExtrasInfo {
    return this.extrasInfoData;
  }

  putUpdateBaggage(flightIdentifier: string, passengerIdentifier: string, bookingReference: string): Observable<ExtrasInfo> {
    const url = `${this.urlService.urls[UrlEnum.PUT_EXTRAS_INFO]}`;
    const headers = { SessionId: this.localStorageService.getUserSessionToken() };
    const body = {
      retrievedFlightIdentifier: flightIdentifier,
      travellerIdentifier: passengerIdentifier,
      extrasOptionCode: bookingReference,
    };
    return this.http.put<ExtrasInfo>(url, body, { headers });
  }

  putUpdateLounge(flightIdentifier: string, passengerIdentifier: string, bookingReference: string): Observable<ExtrasInfo> {
    const url = `${this.urlService.urls[UrlEnum.UPDATE_LOUNGE]}`;
    const headers = { SessionId: this.localStorageService.getUserSessionToken() };
    const body = {
      retrievedFlightIdentifier: flightIdentifier,
      travellerIdentifier: passengerIdentifier,
      extrasOptionCode: bookingReference,
      locale: this.localStorageService.getCulture(),
    };

    return this.http.put<ExtrasInfo>(url, body, { headers });
  }

  putAirportAssistance(
    flightIdentifier: string,
    passengerIdentifier: string,
    extrasOptionCode: string,
    removeOption?: boolean
  ): Observable<ExtrasInfo> {
    const url = `${this.urlService.urls[UrlEnum.UPDATE_AIRPORT_ASSISTANCE]}`;
    const headers = { SessionId: this.localStorageService.getUserSessionToken() };
    const body = {
      retrievedFlightIdentifier: flightIdentifier,
      travellerIdentifier: passengerIdentifier,
      extrasOptionCode: extrasOptionCode,
      removeOption: removeOption ?? false,
      locale: this.localStorageService.getCulture(),
    };

    return this.http.put<ExtrasInfo>(url, body, { headers });
  }

  confirmExtras(flightIdentifier: string): Observable<any> {
    const url = this.urlService.parseDynamicUrl(UrlEnum.POST_CONFIRM_EXTRAS, { flightIdentifier: flightIdentifier });
    const sessionToken = this.localStorageService.getUserSessionToken();
    const authToken = this.localStorageService.getBearerToken();

    const headers = new HttpHeaders({
      SessionId: sessionToken ? sessionToken : '',
      Authorization: authToken ? `Bearer ${authToken}` : '',
    });

    const body = {
      SelectedFlightIdentifier: flightIdentifier,
    };

    return this.http.post(url, body, { headers });
  }
}
